<div class="flex items-center justify-center gap-6 pt-12">
  <div class="text-center rounded-xl bg-greyLight py-4 px-12">
    <div class="text-4xl font-medium pb-2">{{ referred }}</div>
    <div class="text-xl font-medium">referred</div>
  </div>
  <div class="text-center rounded-xl bg-greyLight py-4 px-12">
    <div class="text-4xl font-medium text-orange pb-2">{{ credit }}</div>
    <div class="text-xl font-medium bg-orange px-4 rounded text-white">credit</div>
  </div>
</div>